import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type setDialogOpenParams = {
  isOpen: boolean;
  content: string;
};

type ValidationDialogProps = {
  dialogOpen: boolean;
  setDialogOpen: (params: setDialogOpenParams) => void;
  dialogContent: string;
};

const ValidationDialog: React.FunctionComponent<ValidationDialogProps> = (
  props,
) => {
  const { dialogOpen, setDialogOpen, dialogContent } = props;

  return (
    <Dialog
      open={dialogOpen}
      onOpenChange={(open) => setDialogOpen({ isOpen: open, content: "" })}
    >
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Oops! Something’s missing</DialogTitle>
        </DialogHeader>
        <span className="text-medium font-medium text-gray-700">
          {dialogContent}
        </span>

        <div className="flex justify-end">
          <DialogClose asChild>
            <button
              onClick={() => setDialogOpen({ isOpen: false, content: "" })}
              className="rounded-md bg-primary px-4 py-2 text-white transition hover:bg-blue-700"
            >
              OK
            </button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ValidationDialog;
